import { SingleContentToggle } from 'components/Atoms/SingleContentToggle'
import { SingleAchievement } from './SingleAchievement'
import { MultipleAchievement } from './MultipleAchievement'

export const AchievementItem = ({ data, noToast }) => {
  const { message } = data
  return (
    <SingleContentToggle
      noWrapper
      toggle={message.length > 1}
      trueContent={<MultipleAchievement msg={message} noToast={noToast} />}
      falseContent={<SingleAchievement msg={message.at(0)} noToast={noToast} />}
    />
  )
}
